import * as React from 'react';

import { useFilterContext } from '../../contexts/FiltersContext';
import { MakeFilter } from '../../models/Filter';
import BaseFilterChip from './BaseFilterChip';

type MakeFilterChipProps = {
  filter: MakeFilter;
  value: string;
};

const MakeFilterChip = ({ filter, value }: MakeFilterChipProps) => {
  const { handleRemoveMakeFilter } = useFilterContext();

  return (
    <BaseFilterChip
      filter={filter}
      onRemove={() => {
        filter.removeFn(value);
        handleRemoveMakeFilter(filter.getSelectedValues(), filter);
      }}
      text={value}
    />
  );
};

export default MakeFilterChip;
